import { getInjector } from '../../utils/getInjector';
import { getTrackItem, isSameItem } from './utils';
import slEventBus, { eventMetaMap } from '../../../../utils/slEventBus';

/**
 * @param {object} payload
 * @param {object} payload.itemInfo - The info of item request add to cart.
 * @param {string} payload.itemInfo.product_id - The product id of item request add to cart.
 * @param {string} payload.itemInfo.variation_id - The variation id of item request add to cart.
 * @param {string} payload.itemInfo.type - The type of item request add to cart.
 * @param {object} payload.cartData - The cart data.
 * @param {array} payload.cartData.items - The items in cart.
 * @param {string} [payload.fbPixelEventId] - The event id for fb pixel.
 */
export const onTrackAddItem = async (payload) => {
  const { itemInfo, cartData, fbPixelEventId } = payload;
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');
  const cartService = injector.get('cartService');
  const Analytics = injector.get('Analytics');
  const gaService = injector.get('gaService');
  const productService = injector.get('productService');
  const slFeatureService = injector.get('slFeatureService');
  const $rootScope = injector.get('$rootScope');
  const $filter = injector.get('$filter');

  const addItem = cartData.items.find((item) => isSameItem(item, itemInfo));
  const trackItem = getTrackItem(
    itemInfo.product_id,
    itemInfo.variation_id,
    itemInfo.type,
    cartData.items,
  );

  if (slFeatureService.hasFeature('data_layer_info')) {
    $rootScope.$emit('add.item.to.cart', cartService.getGaItemData(addItem));
  }

  const cartEventOptions = {
    scope: 'one_page_store',
    eventCategoryEmpty: true,
    button_type: 'add_to_cart',
  };
  // for shoplytics
  cartService.tracking(
    trackerService.userActionTypes.ADD_ITEM,
    trackItem,
    cartEventOptions,
  );

  // for third party tracking
  trackerService.track({
    type: trackerService.generalEventType.ADD_TO_CART,
    data: {
      items: [
        {
          product: {
            ...addItem.product,
            _id: addItem.product_id,
          },
          value: addItem.price.dollars,
          quantity: 1,
          variationSelected: addItem?.variation
            ? {
                ...addItem.variation,
                _id: addItem.variation_id,
              }
            : null,
        },
      ],
      scope: 'one_page_store',
      ...(fbPixelEventId && { eventId: fbPixelEventId }),
    },
  });

  // for storefront sdk
  slEventBus.emit(eventMetaMap.cart.itemAdded, cartData);

  if (Analytics.configuration.enhancedEcommerce) {
    try {
      gaService.setUserId();

      Analytics.addProduct(
        productService.getSku(
          addItem.product_id,
          addItem.product.sku,
          addItem.variation
            ? {
                ...addItem.variation,
                key: addItem.variation_id,
              }
            : null,
        ),
        $filter('translateModel')(addItem.product.title_translations),
        '',
        '',
        productService.getVariationName(addItem.variation),
        cartService.getItemPrice(addItem)?.dollars?.toString(),
        addItem.quantity.toString(),
        '',
        '0',
      );
      Analytics.trackCart('add');
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
};
